import React from "react";

export function ColoredDot({ type }: { type: "success" | "error" }) {
  return (
    <span
      style={{
        display: "inline-block",
        width: 6,
        height: 6,
        background:
          type === "success" ? "rgba(0,200,0,0.8)" : "rgba(200,0,0,0.8)",
        borderRadius: "50%",
        verticalAlign: "middle",
      }}
    />
  );
}
